import React from 'react';

interface PinterestIconProps {
  width?: number;
  height?: number;
  className?: string;
}

export default function PinterestIcon({ width = 22, height = 22, className = '' }: PinterestIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 22 22"
      fill="none"
      className={className}
    >
      <path
        d="M11 21.4827C16.799 21.4827 21.5 16.7856 21.5 10.9914C21.5 5.19714 16.799 0.5 11 0.5C5.20101 0.5 0.5 5.19714 0.5 10.9914C0.5 16.7856 5.20101 21.4827 11 21.4827Z"
        fill="white"
      />
      <path
        d="M11 0.5C5.20123 0.5 0.5 5.19737 0.5 10.9914C0.5 15.4383 3.26543 19.2377 7.1716 20.766C7.07654 19.9371 6.99877 18.6591 7.20617 17.7525C7.3963 16.9322 8.43333 12.537 8.43333 12.537C8.43333 12.537 8.12222 11.9067 8.12222 10.9827C8.12222 9.52344 8.96914 8.43544 10.0235 8.43544C10.9222 8.43544 11.3543 9.10896 11.3543 9.91201C11.3543 10.81 10.784 12.1571 10.4815 13.4091C10.2309 14.4539 11.0086 15.3088 12.037 15.3088C13.9037 15.3088 15.3383 13.34 15.3383 10.5078C15.3383 7.99507 13.5321 6.24219 10.9481 6.24219C7.95803 6.24219 6.2037 8.47862 6.2037 10.7928C6.2037 11.6908 6.54938 12.6579 6.98148 13.1846C7.0679 13.2882 7.07654 13.3832 7.05062 13.4868C6.97284 13.815 6.79136 14.5317 6.75679 14.6785C6.71358 14.8684 6.60123 14.9116 6.40247 14.8166C5.08889 14.2035 4.2679 12.2952 4.2679 10.7496C4.2679 7.44243 6.67037 4.40296 11.2074 4.40296C14.8457 4.40296 17.6802 6.99342 17.6802 10.4646C17.6802 14.0826 15.3988 16.9926 12.2358 16.9926C11.1728 16.9926 10.1704 16.44 9.83333 15.7837C9.83333 15.7837 9.30617 17.787 9.17654 18.2792C8.94321 19.1945 8.3037 20.3343 7.87161 21.0337C8.85679 21.3359 9.89383 21.5 10.9827 21.5C16.7815 21.5 21.4828 16.8026 21.4828 11.0086C21.5 5.19737 16.7988 0.5 11 0.5Z"
        fill="#4B5563"
      />
    </svg>
  );
}
